import { render, staticRenderFns } from "./DatosGenerales.vue?vue&type=template&id=8ec8a7e4&"
import script from "./DatosGenerales.vue?vue&type=script&lang=ts&"
export * from "./DatosGenerales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8ec8a7e4', component.options)
    } else {
      api.reload('8ec8a7e4', component.options)
    }
    module.hot.accept("./DatosGenerales.vue?vue&type=template&id=8ec8a7e4&", function () {
      api.rerender('8ec8a7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaCliente/Editar/DatosGenerales.vue"
export default component.exports